'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './station_areas.routes';

export class StationAreasComponent {
  /*@ngInject*/
  constructor($scope, $state, $timeout, lookup, fetch, userService,) {
    this.$scope = $scope;
    this.fetch = fetch;
    this.lookup = lookup;
    this.$state = $state;        
    this.$timeout = $timeout;    

  this.userService = userService;

    $scope.rowCollection = [];
    $scope.filteredCollection = [];

    /**
     * Updates the station area details (active, status, service_tier) in the database.
     * This function is typically called via ng-change on editable fields in a table row.
     * @param {object} item - The station area item object from the rowCollection with sta_recid, active, status, and service_tier properties.
     */
    $scope.updateStationDetails = function(item) {
      if (!this.$scope.currentUser || !this.$scope.currentUser.firstname) {
        item.updateError = true;
        item.errorMessage = 'User information missing. Cannot save.';
        this.$timeout(() => {
            item.updateError = false;
            item.errorMessage = '';
        }, 5000);
        return; // Prevent saving if user info is missing
      }

      const editorName = `${this.$scope.currentUser.firstname} ${this.$scope.currentUser.lastname}`;
      
      console.log(`Updating sta_recid: ${item.sta_recid} with details:`, {
        active: item.active,
        status: item.status,
        service_tier: item.service_tier,
        updated_by: editorName
      });
      
      item.savingStatus = true;
      item.updateSuccess = false;
      item.updateError = false;
      item.errorMessage = '';

      const payload = {
        sta_recid: item.sta_recid,
        active: item.active, 
        status: item.status, 
        service_tier: item.service_tier,
        updated_by: editorName
      };

      fetch.updateItem('api/data/station-areas/update', payload)
        .then(response => {
          console.log('Update successful:', response);
          item.updateSuccess = true;
          this.$timeout(() => { 
            item.updateSuccess = false;
          }, 3000); 
        })
        .catch(err => {
          console.error('Error updating station details:', err);
          item.updateError = true;
          item.errorMessage = err.data && err.data.error ? err.data.error : 'Save failed. Please try again.';
          
          this.$timeout(() => { 
            item.updateError = false;
            item.errorMessage = '';
          }, 5000); 

          if(err.status === 403) {
            this.$state.go('login');
          }
        })
        .finally(() => {
          item.savingStatus = false;
        });
    }.bind(this); 
  
    $scope.editRow = function(itemInRow) { 
      console.log("editRow called for item:", itemInRow);
      if (itemInRow) {
       
        itemInRow.editing = true;
        console.log("item.editing set to true");
      } else {
        console.error("editRow called with undefined item");
      }
    };
    

    $scope.saveChanges = function(itemInRow) {
      console.log("saveChanges called for item:", itemInRow);
      $scope.updateStationDetails(itemInRow); 
    };


$scope.cancelEdit = function(itemInRow) {
  console.log("cancelEdit called for item:", itemInRow);
  if (itemInRow) {
    itemInRow.editing = false;
    itemInRow.updateSuccess = false;
    itemInRow.updateError = false;
    itemInRow.errorMessage = '';
    console.log("item.editing set to false");
  } else {
    console.error("cancelEdit called with undefined item");
  }
};

  
  }

  $onInit(){

    
    this.userService.getCurrentUser()
    .then(response => {
      
      this.$scope.currentUser = response.data;
      this.userService.setCurrentUser(response.data);
      this.getStationAreasList()

    })
    .catch(err => {
      console.log(err);
      if(err.status === 403){
        this.$state.go('login');
      }
    })
   
  }


getStationAreasList() {
  this.fetch.getAllItems('api/data/stations/station-admin')
    .then(function(response) {
      if (response && response.data) {
        var stationData = response.data;
        

        for (var i = 0; i < stationData.length; i++) {
          var item = stationData[i];
          

          item.active = typeof item.active === 'string' ? (item.active === 'true') : Boolean(item.active);
          

          item.savingStatus = false;
          item.updateSuccess = false;
          item.updateError = false;
          item.errorMessage = '';
        }
        
        this.$scope.rowCollection = stationData;

        this.$scope.filteredCollection = this.$scope.rowCollection; 
      } else {
        this.$scope.rowCollection = [];
        this.$scope.filteredCollection = [];
      }
    }.bind(this))
    .catch(function(err) {

      console.log(err);
      if (err.status === 403) {

        if (this.$state) { 
          this.$state.go('login');
        } else {
          console.error('$state service not available for redirection. Ensure it is injected in the constructor.');
        }
      }
    }.bind(this)); 
}
}

export default angular.module('appApp.station_areas', [uiRouter, 'smart-table'])
  .config(routes)
  .component('stationAreas', {
    template: require('./station_areas.html'),
    controller: StationAreasComponent,
    controllerAs: 'stationAreasCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/compliance/station_areas/station_areas.component.js